import { render } from "./QuestionInfo.vue?vue&type=template&id=016ddcc4&scoped=true"
import script from "./QuestionInfo.vue?vue&type=script&lang=js"
export * from "./QuestionInfo.vue?vue&type=script&lang=js"

import "./QuestionInfo.vue?vue&type=style&index=0&id=016ddcc4&lang=less&scoped=true"
import "./QuestionInfo.vue?vue&type=style&index=1&id=016ddcc4&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016ddcc4"]])

export default __exports__